import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={9}
    height={21}
    viewBox="0 0 9 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.2496 19.7289C5.91848 21.06 3.74705 21.06 2.41595 19.7289C1.08486 18.3978 1.08486 16.2264 2.41595 14.8953C3.74705 13.5642 5.91846 13.5641 7.2496 14.8953C8.58073 16.2264 8.58069 18.3978 7.2496 19.7289ZM5.86359 0.549142L6.14603 8.60858L8.72883 8.51775L4.69609 13.0979L0.352307 8.81149L2.93489 8.72089L2.65201 0.66167L5.86359 0.549142Z"
      fill="#636F7C"
    />
  </svg>
);
export default SVGComponent;
